<template>
  <v-card elevation="2">
    <v-toolbar color="teal" dark flat>
      <v-icon left>mdi-medical-bag</v-icon>
      <v-toolbar-title>Medical Records</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('add-medical-file')" v-if="canEdit">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <v-tabs v-model="tab" background-color="teal lighten-5">
      <v-tab>
        <v-icon left>mdi-file-document-multiple</v-icon>
        Records
      </v-tab>
      <v-tab>
        <v-icon left>mdi-history</v-icon>
        History
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <!-- Medical Files Tab -->
      <v-tab-item>
        <v-card-text v-if="medicalFiles.length === 0" class="text-center py-8">
          <v-icon size="64" color="grey lighten-1">mdi-file-medical</v-icon>
          <p class="text-h6 grey--text mt-4">No medical records yet</p>
          <v-btn
            color="teal"
            dark
            @click="$emit('add-medical-file')"
            v-if="canEdit"
          >
            <v-icon left>mdi-plus</v-icon>
            Create First Record
          </v-btn>
        </v-card-text>

        <v-list v-else three-line>
          <template v-for="(file, index) in medicalFiles">
            <v-list-item :key="file.id">
              <v-list-item-avatar color="teal lighten-4">
                <v-icon color="teal darken-2">mdi-stethoscope</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="font-weight-medium">
                  {{ file.chief_complaint }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  <strong>Date:</strong> {{ formatDate(file.visit_date) }}
                </v-list-item-subtitle>
                <v-list-item-subtitle v-if="file.diagnosis">
                  <strong>Diagnosis:</strong> {{ file.diagnosis }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action v-if="canEdit">
                <v-menu bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="$emit('view-medical-file', file)">
                      <v-list-item-icon>
                        <v-icon>mdi-eye</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>View</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('edit-medical-file', file)">
                      <v-list-item-icon>
                        <v-icon>mdi-pencil</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Edit</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="$emit('delete-medical-file', file.id)">
                      <v-list-item-icon>
                        <v-icon color="red">mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              :key="'div-' + index"
              v-if="index < medicalFiles.length - 1"
            ></v-divider>
          </template>
        </v-list>
      </v-tab-item>

      <!-- Medical History Tab -->
      <v-tab-item>
        <v-card-text
          v-if="medicalHistory.length === 0"
          class="text-center py-8"
        >
          <v-icon size="64" color="grey lighten-1">mdi-history</v-icon>
          <p class="text-h6 grey--text mt-4">No medical history available</p>
        </v-card-text>

        <v-timeline v-else dense>
          <v-timeline-item
            v-for="item in medicalHistory"
            :key="item.id"
            small
            color="teal"
          >
            <template v-slot:icon>
              <v-icon small color="white">mdi-medical-bag</v-icon>
            </template>
            <v-card>
              <v-card-title class="text-subtitle-1">
                {{ item.chief_complaint }}
              </v-card-title>
              <v-card-subtitle>
                {{ formatDate(item.visit_date) }}
              </v-card-subtitle>
              <v-card-text v-if="item.diagnosis">
                <strong>Diagnosis:</strong> {{ item.diagnosis }}
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  name: "MedicalFiles",

  props: {
    medicalFiles: {
      type: Array,
      default: () => [],
    },
    medicalHistory: {
      type: Array,
      default: () => [],
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    tab: 0,
  }),

  methods: {
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>
